/* ==========================================================================
   KAMOR — interacciones

   NOTA: el copy del hero ya NO se mueve con el scroll. El efecto sticky se
   retiro porque durante la carga, antes de que la imagen del hero fijara su
   alto, el texto se posicionaba mal y saltaba. Ahora es texto estatico
   dentro del hero (ver kamor-custom.css). No reintroducir.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Header compacto al hacer scroll
     --------------------------------------------------------------- */
  function initScrollChrome() {
    var ticking = false;

    function update() {
      var y = window.scrollY || 0;
      document.body.dataset.kamorScrolled = y > 24 ? 'true' : 'false';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* ---------------------------------------------------------------
     Reveal al hacer scroll
     --------------------------------------------------------------- */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var targets = document.querySelectorAll('.product-grid__card, .card');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.dataset.revealed = 'true';
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    targets.forEach(function (el, i) {
      if (el.dataset.kamorObserved === 'true') return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      el.dataset.kamorObserved = 'true';
      el.classList.add('kamor-reveal');
      el.style.transitionDelay = Math.min((i % 4) * 60, 180) + 'ms';
      observer.observe(el);
    });
  }

  function boot() {
    try { initReveal(); } catch (e) {}
  }

  function bootOnce() {
    try { initScrollChrome(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootOnce();
      boot();
    });
  } else {
    bootOnce();
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();
